import type { AiBusinessCenterModule } from '../types'

export const pmsModule: AiBusinessCenterModule = {
  key: 'pms',
  label: '项目管理',
  desc: '项目列表 / 项目模板 / 迭代管理 / 知识库与文档协作',
  path: '/pms',
  homePath: '/pms/pm/project/list',
  icon: 'ep:folder',
  color: '#6366f1',
  aliases: ['PMS', '项目管理', '项目协作', '知识库', '项目']
}
